/* eslint-disable */
import React, { useRef, useEffect, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import Barcode from 'react-barcode';
import numeral from 'numeral'; 
import {
  faTag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Dropdown
} from 'react-bootstrap';


class ComponentToPrint extends React.Component {

  render() {
    return (
      <>
      <div style={{ border: '2px solid #000', width: 620, height: 960, padding: 10, margin: 10, transform: 'rotate(-90deg)', position: 'absolute', top: -160, left: 180 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #000', height: 110}}>
        <div style={{ width: 100, height: 'auto'}}>
          <img src={this.props.empresa.logo_guia} style={{ width: '100%' }} alt="Logo"/>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <div><b>{this.props.empresa.nombre_empresa.toUpperCase()}</b></div>
          <div>{this.props.empresa.rut_empresa}</div>
          <div>{this.props.empresa.direccion_empresa}</div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 15, paddingBottom: 15 }}>
          <div style={{ fontWeight: 'bold' }}>Destinatario</div>
          <div style={{ fontSize: 18 }}>{this.props.guide.cliente_receptor_identificacion.toUpperCase()}</div>
    <div style={{ fontSize: 18 }}>{this.props.guide.cliente_receptor_nombre}</div>
          <div style={{ fontSize: 18 }}>{this.props.guide.cliente_receptor_telefono}</div>
          <div style={{ marginTop: 10 }}>
            <div style={{ fontWeight: 'bold' }}>Dirección de entrega</div>
            <div>
              {this.props.guide.cliente_receptor_direccion_entrega}
            </div>
          </div>
        </div>
      </div>

      <div style={{ flexDirection:'column', display: 'flex', justifyContent: 'center', borderBottom: '2px solid #000', borderTop: '2px solid #000', alignItems: 'center', marginTop: 10, padding: 10, paddingTop: 15, paddingBottom: 15 }}>
        <small>Guia de envio</small>
        <h1 style={{ margin: 0, fontSize: 65 }}>{`${this.props.showPrefixGuide ? this.props.guide.master_guia.rel_tipos.prefijo : this.props.prefijo}-${this.props.guide.guia_paquete}`}</h1>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, paddingTop: 15, paddingBottom: 15 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ fontWeight: 'bold' }}>Registrado</div>
          <div style={{ fontSize: 18 }}>{moment(this.props.guide.createdAt).format('DD/MM/YYYY H:s')}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ fontWeight: 'bold' }}>Peso</div>
          <div style={{ textAlign: 'center', width: '100%', fontSize: 18}}>{this.props.peso} KG</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ fontWeight: 'bold' }}>Ft3</div>
          <div style={{ textAlign: 'center', width: '100%', fontSize: 18}}>{this.props.pie}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ fontWeight: 'bold' }}>Bultos total</div>
          <div style={{ textAlign: 'center', width: '100%', fontSize: 18}}>{this.props.guide.bultos.length}</div>
        </div>
      </div>

      <div style={{ flexDirection:'column', display: 'flex', justifyContent: 'center', borderBottom: '2px solid #000', borderTop: '2px solid #000', alignItems: 'center', marginTop: 10, padding: 10, paddingTop: 15, paddingBottom: 15  }}>
            <small>Tipo de envio : <b>{this.props.guide.master_guia.rel_tipos.description}</b></small>
            <h1 style={{ margin: 0, fontSize: 65 }}>{this.props.guide.estado_guia.estado.toUpperCase() }</h1>
            <small style={{ margin: 0, padding: 0 }}><b>{this.props.guide.ciudad_guia.ciudad.toUpperCase()}</b></small>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,marginTop: 10}}>
        <Barcode displayValue={false} value={this.props.guide.uuid} height={100} width={1.3} margin={0} />
      </div>
    </div>
    </>
    );
  }
}
 
const PrinterGuideV2 = ({ data, prefijo, empresa, disabled, showPrefixGuide }) => {

  const [peso, setPeso] = useState(0);
  const [pie, setPie] = useState(0);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  const calculatePeso = () => {
    let peso_total = 0;
    let pie_total = 0;
    data.bultos.forEach(e => {
      peso_total += parseFloat(e.peso);
      pie_total += parseFloat(e.pie);
    });
    let fPeso = numeral(peso_total).format('0.00')
    let fPie = numeral(pie_total).format('0.00')

    setPeso(fPeso);
    setPie(fPie);
  }

  useEffect(() => {
    calculatePeso()
  },[])

  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint 
          guide={data}
          empresa={empresa}
          prefijo={prefijo}
          peso={peso}
          pie={pie}
          ref={componentRef}
          showPrefixGuide={showPrefixGuide}
        />
      </div>
      <Dropdown.Item disabled={disabled} onClick={handlePrint}>
        <FontAwesomeIcon icon={faTag} /> Imprimir guia
      </Dropdown.Item>
    </div>
  );
};

export default PrinterGuideV2;